module.exports = __webpack_public_path__ + "img/symbol_13_normal.cd276ea5.png";